import type { TastytradeSession } from "@/types/tastytrade";

function normalizeSessionUser(user: unknown): TastytradeSession["user"] {
  if (!user || typeof user !== "object") {
    return {
      email: "",
      username: "",
      "external-id": "",
    };
  }

  const record = user as Record<string, unknown>;

  const email = typeof record.email === "string" ? record.email : "";
  const username = typeof record.username === "string"
    ? record.username
    : typeof record["external-id"] === "string"
      ? String(record["external-id"])
      : typeof record.id === "string"
        ? record.id
        : "";
  const externalId = typeof record["external-id"] === "string"
    ? record["external-id"]
    : typeof record.externalId === "string"
      ? record.externalId
      : username;

  return {
    email,
    username,
    "external-id": externalId ?? "",
  };
}

export function buildSession(
  sessionToken: string,
  user: unknown,
  expiration?: string,
): TastytradeSession {
  const sessionExpiration =
    typeof expiration === "string" && expiration.trim().length > 0
      ? expiration
      : new Date(Date.now() + 60 * 60 * 1000).toISOString();

  return {
    "session-token": sessionToken,
    user: normalizeSessionUser(user),
    "session-expiration": sessionExpiration,
  };
}

export function getErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error && error.message) {
    return error.message;
  }
  if (error && typeof error === "object" && "message" in error) {
    const message = (error as { message?: unknown }).message;
    if (typeof message === "string" && message.trim()) {
      return message;
    }
  }
  return fallback;
}
